import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";

interface HeroSectionProps {
  title?: React.ReactNode;
  subtitle?: string;
  /**
   * Уменьшенные отступы для посадочных: там человек пришёл с конкретного запроса
   * и форма загрузки должна попадать в первый экран, а не уходить за него.
   */
  compact?: boolean;
}

export const HeroSection: React.FC<HeroSectionProps> = ({ title, subtitle, compact = false }) => {
  const [titleNumber, setTitleNumber] = useState(0);
  const titles = useMemo(() => ["видео", "аудио", "лекцию", "созвон", "подкаст", "интервью"], []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (titleNumber === titles.length - 1) {
        setTitleNumber(0);
      } else {
        setTitleNumber(titleNumber + 1);
      }
    }, 2000);
    return () => clearTimeout(timeoutId);
  }, [titleNumber, titles]);

  const defaultTitle = (
    <>
      Вставьте{" "}
      <span className="relative inline-block h-[1.15em] w-[5.5em] overflow-hidden align-bottom">
        {titles.map((word, index) => (
          <motion.span
            key={word}
            className="absolute inset-0 text-center font-semibold leading-[1.15em] text-primary sm:text-left"
            initial={{ opacity: 0, y: "-100" }}
            transition={{ type: "spring", stiffness: 50, damping: 20 }}
            animate={titleNumber === index ? { y: 0, opacity: 1 } : { y: titleNumber > index ? -150 : 150, opacity: 0 }}
          >
            {word}
          </motion.span>
        ))}
      </span>{" "}
      —<br />
      получите <span className="text-primary">текст</span>
    </>
  );

  const defaultSubtitle =
    "Ссылка или файл: спикеры, таймкоды и AI-сводка. Часовой файл расшифровывается за несколько минут.";

  return (
    <section className="relative overflow-hidden bg-background">
      <div className={compact ? "container pt-10 md:pt-14 pb-0" : "container pt-14 md:pt-20 pb-0"}>
        <div className="mx-auto max-w-3xl text-center">
          <h1 className="mb-5 text-4xl font-bold !leading-[1.15] tracking-tight text-foreground sm:text-5xl md:text-6xl text-balance">
            {title || defaultTitle}
          </h1>

          <p className="mb-7 text-lg text-muted-foreground text-pretty md:text-xl">{subtitle || defaultSubtitle}</p>

          <p className="mb-3 mt-6 text-sm font-light text-muted-foreground">
            Файлы и ссылки: YouTube, VK Video, Rutube, OK, Дзен. До 2 ГБ.
          </p>
        </div>
      </div>
    </section>
  );
};
